/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const RtwDetailsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 34 20"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18,18 L12.7813333,12.7813333 C21.112,8.40133333 31.3333333,8.40933333 31.3333333,18 C31.3333333,3.61333333 18.7186667,0.721333333 5.016,4.98533333 L0.666666667,0.666666667 L0.666666667,18 L18,18 Z" />
    </g>
  </svg>
);

export default RtwDetailsIcon;
